/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M13.7687 20.0803c-3.1498 3.1498-8.2566 3.1498-11.4064 0-3.1497-3.1498-3.1497-8.2566 0-11.4063l6.864-6.864a.7852.7852 0 0 1 1.1104 1.1103l-6.864 6.864c-2.5366 2.5365-2.5366 6.6491 0 9.1857 2.5365 2.5365 6.6491 2.5365 9.1856-.0001l8.5798-8.5799c1.5889-1.5889 1.5889-4.1649 0-5.7537-1.5888-1.5888-4.1648-1.5888-5.7536 0l-4.568 4.568a1.9529 1.9529 0 0 1-.0078.008l-4.004 4.0039c-.6411.6411-.6411 1.6806 0 2.3217.641.6411 1.6805.6411 2.3216 0l6.864-6.864a.7852.7852 0 0 1 1.1104 1.1103l-6.864 6.864c-1.2544 1.2544-3.288 1.2544-4.5424 0-1.2543-1.2543-1.2543-3.288 0-4.5423l8.5798-8.58c2.2021-2.202 5.7723-2.202 7.9744 0 2.202 2.2021 2.202 5.7724 0 7.9744l-3.4223 3.4223-.0095.0097-5.148 5.148Z"
    clipRule="evenodd"
  />,
  'Attach'
);
